import React from 'react'
import { Star24, StarFilled24, TrashCan24 } from '@carbon/icons-react'

const RadioElement = React.memo(({ filterItem, ...props }) => {
  const { id, name, label, favorite } = filterItem
  const { onChange, onChangeFavorite, onDeleteFilter, checked } = props

  return (
    <div className='filter-item'>
      <input
        type='radio'
        name={name}
        id={id}
        value={id}
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor={id}>{label ?? name}</label>
      {id !== 0 ? (
        <div className='filter-item-icons'>
          {favorite ? (
            <StarFilled24
              className='star-filled'
              onClick={() => onChangeFavorite(filterItem)}
            />
          ) : (
            <Star24
              className='star-empty'
              onClick={() => onChangeFavorite(filterItem)}
            />
          )}
          <TrashCan24
            className='trash'
            onClick={() => onDeleteFilter({ id, name })}
          />
        </div>
      ) : null}
    </div>
  )
})

const RadioForm = ({
  t,
  filterList,
  selectedValue,
  setSelectedValue,
  favorite,
  onChangeFavorite,
  onDeleteFilter
}) => {
  const listWithNoneValue = [
    { id: 0, name: 'None', label: t('None') },
    ...filterList
  ]

  const onChange = (e) => {
    setSelectedValue(parseInt(e.target.value))
  }

  return (
    <form className='filter-list'>
      {listWithNoneValue.map((item) => (
        <RadioElement
          filterItem={item}
          onChange={onChange}
          key={`radio-item-${item.id}`}
          favorite={favorite?.id === item.id}
          onChangeFavorite={onChangeFavorite}
          onDeleteFilter={onDeleteFilter}
          checked={selectedValue === item.id || selectedValue === item.name}
        />
      ))}
    </form>
  )
}

export default React.memo(RadioForm)
